 export enum TypeJournee {
JourneeEntiere = 1,
Matin = 2,
ApresMidi = 3,
}


// WEBPACK FOOTER //
// ./src/dto/GenApi.iNotPaie.Dto/TypeJournee.ts